// sessionStorage-backed persistence for per-report column visibility.
// Keys look like `wxccOps:reportCols:v1:${reportId}` so multiple reports
// don't collide and the key is bumped if the schema changes.
//
// Null-safe: if sessionStorage is unavailable (SSR, private tabs, quota),
// everything degrades to in-memory and column prefs just reset per tab.

const KEY_PREFIX = 'wxccOps:reportCols:v1:';

export function loadColumnPrefs(reportId, defaultVisibleIds) {
  if (typeof sessionStorage === 'undefined') return defaultVisibleIds;
  try {
    const raw = sessionStorage.getItem(KEY_PREFIX + reportId);
    if (!raw) return defaultVisibleIds;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return defaultVisibleIds;
    return parsed.filter((x) => typeof x === 'string');
  } catch {
    return defaultVisibleIds;
  }
}

export function saveColumnPrefs(reportId, visibleIds) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(KEY_PREFIX + reportId, JSON.stringify(visibleIds));
  } catch {
    // quota exceeded or private tab — silent fail
  }
}
